'use client';

import { useState } from 'react';

import { PageBlock } from '@/payload/payload-types-block';
import { UiBannerPicture } from '@/ui/banner-picture';
import { UiToolSliderFading } from '@/ui-tool/slider-fading';

import { Form } from './components/Form';
import { styles } from './FeatureSubscriptionForm.styles';

type SubscriptionBanner = PageBlock<'subscriptionBanner'>;

export interface FeatureSubscriptionFormProps extends SubscriptionBanner {
  className?: string;
}

export function FeatureSubscriptionForm({
  image,
  title,
  titleTheme,
  firstLine,
  secondLine,
  className
}: FeatureSubscriptionFormProps) {
  const slots = styles();

  const [key, setKey] = useState(1);

  return (
    <div className={slots.base({ className })}>
      <div className={slots.banner()}>
        {typeof image !== 'number' && image.sizes && (
          <UiBannerPicture
            sizes={image.sizes}
            customSizes={image.customSizes}
            alt={image.alt}
            desktopFieldName="banner-subscription-desktop"
            mobileFieldName="banner-subscription-mobile"
          />
        )}

        <div className={slots.bannerTitleWrapper()}>
          {title && (
            <UiToolSliderFading
              className={slots.bannerTitle({ theme: titleTheme ?? 'light' })}
              containerClassName={slots.bannerTitleContainer()}
            >
              <span>{title}</span>
            </UiToolSliderFading>
          )}
        </div>
      </div>

      <div className={slots.content()}>
        <div className={slots.formTitle()}>
          {firstLine && <span className={slots.formTitleFirstLine()}>{firstLine}</span>}

          {secondLine && (
            <span className={slots.formTitleSecondLine()}>{secondLine}</span>
          )}
        </div>

        <Form
          key={key}
          className={slots.form()}
          onReset={() => {
            setKey((prev) => prev + 1);
          }}
        />
      </div>
    </div>
  );
}
